export default __webpack_public_path__ + "static/media/bigLogo.0f0175ae.svg";